import React from "react";

export function StatCard({ label, value, sub, accent = "default", testid }) {
  const accents = {
    default: "text-zinc-900",
    green: "text-emerald-700",
    amber: "text-amber-700",
    red: "text-red-700",
    blue: "text-blue-700",
  };
  return (
    <div className="bg-white border border-zinc-200 rounded-md p-6 flex flex-col gap-2 h-full" data-testid={testid}>
      <span className="label-overline">{label}</span>
      <span className={`text-4xl font-display font-black tracking-tight ${accents[accent]}`}>{value}</span>
      {sub && <span className="text-xs text-zinc-500">{sub}</span>}
    </div>
  );
}
